import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=672d44a2&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=672d44a2&prod&scoped=true&lang=css&"
import style1 from "./TextEditor.vue?vue&type=style&index=1&id=672d44a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d44a2",
  null
  
)

export default component.exports